import { useRef, useState, useEffect } from "react";
import moment from "moment";

import {
  PlayerFrame,
  PlayerWrapper,
  PlayerMain,
  LoaderWrapper,
} from "./Detail.styled";
import PlayerHeader from "../PlayerHeader";
import DetailHeader from "../DetailHeader";
import GameInfo from "../GameInfo";
import { sendEvent } from "../../services/tracking";

function Detail({ selectedGame, theme }) {
  const playerRef = useRef();
  const [showGameInfo, setShowGameInfo] = useState(false);
  const [showGameLoader, setShowGameLoader] = useState(true);

  useEffect(() => {
    if (!selectedGame) return;

    const getTrackingLabel = () => {
      switch (selectedGame.category) {
        case "puzzle":
          return selectedGame?.name
            ? moment(new Date(selectedGame?.name)).format("DD-MM-YY")
            : selectedGame.category;
        default:
          return selectedGame.name;
      }
    };

    sendEvent(
      "GAME",
      `${getTrackingLabel()}-${selectedGame.gameType}`,
      `GAME_STARTED`
    );

    const intervalId = setInterval(() => {
      sendEvent(
        "GAME",
        `${getTrackingLabel()}-${selectedGame.gameType}`,
        "GAME_PLAY_INTERVAL"
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, [selectedGame]);

  const onLoadFrame = () => {
    if (!playerRef?.current) return;

    setShowGameLoader(false);

    const selectedTheme = theme && theme === "dark" ? "dark" : "light";

    setTimeout(() => {
      playerRef.current.contentWindow.postMessage(
        {
          message: "game-init",
          gameData: selectedGame.gameData,
          theme: selectedTheme,
        },
        "*"
      );
    }, 1000);
  };

  const onFullscreen = () => {
    const elem = playerRef.current;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  };

  const onInfo = () => {
    setShowGameInfo(!showGameInfo);
  };

  return (
    <>
      <DetailHeader
        description={selectedGame?.name}
        title={
          selectedGame?.gameType === "quiz"
            ? selectedGame?.name
            : selectedGame?.description
        }
      />
      <PlayerWrapper>
        <PlayerHeader onFullscreen={onFullscreen} onInfo={onInfo} />
        <PlayerMain>
          {showGameLoader && (
            <LoaderWrapper>
              <img src="/loading.gif" alt="loading" />
            </LoaderWrapper>
          )}

          {selectedGame && (
            <PlayerFrame
              onLoad={onLoadFrame}
              ref={playerRef}
              src={selectedGame.playerUrl}
              title="description"
              frameBorder="0"
              style={{
                height: 824,
                width: 824,
              }}
            />
          )}

          {showGameInfo && (
            <GameInfo instructionsUrl={selectedGame.instructionsUrl} />
          )}
        </PlayerMain>
      </PlayerWrapper>
    </>
  );
}

export default Detail;
